import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right-small",
  "use": "chevron-right-small-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-right-small\">\n    <path d=\"M5.353.647a.5.5 0 0 0-.706.707l.706-.707zM9 5l.354.354a.5.5 0 0 0 0-.707L9 4.999zM4.646 8.647a.5.5 0 1 0 .708.707l-.708-.707zm0-7.293 4 3.999.707-.707-4-3.999-.706.707zm4 3.292-4 4.001.708.707 4-4.001-.708-.707z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol